import { render, staticRenderFns } from "./umpayer.vue?vue&type=template&id=09386cb9&scoped=true&"
import script from "./umpayer.vue?vue&type=script&lang=js&"
export * from "./umpayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09386cb9",
  null
  
)

export default component.exports